<template>
  <div>
    <v-row>
      <v-col cols="12">
        <v-checkbox
            :error-messages="error"
            v-model="isChecked"
        >
          <template #label>
            <div>
              {{
                translation(translationList.has_road_assistance, 'Confirm, doresc asistență rutieră gratuită')
              }} - <NuxtLink to="/info/road-assistance" target="_blank">{{ translation(translationList.road_assistance_terms, 'Vezi detalii') }}</NuxtLink>
            </div>
          </template>
        </v-checkbox>
      </v-col>
    </v-row>
  </div>
</template>

<script lang="ts">
import {defineComponent, ref, watch, onMounted, type PropType} from 'vue';
import {useTranslationStore, translation} from "~/plugins/store/translations";
import type {TranslationList} from "~/types/Utils";

export default defineComponent({
  name: 'HasRoadAssistance',
  props: {
    modelValue: {
      type: [Boolean, null] as PropType<boolean | null>,
      default: false,
    }
  },
  setup(props, {emit}) {
    const isChecked = ref(props.modelValue);
    const translationList = ref<TranslationList>({});
    const translationStore = useTranslationStore();
    const error = ref<string[]>([]);

    watch(isChecked, (newValue) => {
      emit('update:modelValue', newValue);
    });

    watch(() => props.modelValue, (newValue) => {
      isChecked.value = newValue;
      error.value = [];
      const isValid = isChecked.value;
      emit('validation-road-assistance-status', {field: 'has_road_assistance', isValid});
    });

    onMounted(async () => {
      translationList.value = await translationStore.getTranslations('ro', 'dashboard');

      // Listen for validate event
      window.addEventListener('validate-road-assistance', (data) => {
        if (data.detail && data.detail === 'has_road_assistance') {
          if (!isChecked.value) {
            error.value = [translation(translationList.value.required_road_assistance, 'Te rugăm să citești și să accepți termenii și condițiile pentru a putea continua')];
          } else {
            error.value = [];
            emit('validation-road-assistance-status', {field: 'has_road_assistance', isValid: true});
          }
        }
      });
    });

    return {
      isChecked,
      translationList,
      translation,
      error,
    };
  },
});
</script>

<style scoped>
</style>